import React, { useRef } from 'react'
import { Text } from '@mafc/trolly'
import { COLORS, i18n } from '@mafc/common'
import { BackToTopWrapper } from './BackToTop.styles'

const BackToTop: React.FunctionComponent = () => {
  const onClick = useRef(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  })

  return (
    <BackToTopWrapper onClick={onClick.current}>
      <Text testid='back-to-top-text' color={COLORS.WHITE}>
        {i18n.t('backToTop')}
      </Text>
    </BackToTopWrapper>
  )
}

export default BackToTop
